const faqContent = [
  {
    question: 'Tem algum custo criar um evento de ciclismo no Riderize?',
    answer:
      'Não, a criação de um ou mais eventos de ciclismo é totalmente gratuita, você só paga uma comissão caso venda alguma coisa dentro da plataforma, seja uma inscrição, um produto ou serviço.'
  },
  {
    question: 'Quem pode criar um desafio?',
    answer: 'Qualquer pessoa pode criar um evento de ciclismo no Riderize.'
  },
  {
    question: 'Consigo criar um evento sozinho dentro da plataforma?',
    answer:
      'Sim, basta fazer login na plataforma e seguir o passo a passo para construir a sua prova ou desafio em poucos minutos.'
  },
  {
    question: 'Preciso controlar vendas e inscrições pagas manualmente?',
    answer:
      'Não, o Riderize calcula e controla tudo de forma automática e você tem acesso a um relatório financeiro detalhado com todas as informações das vendas efetuadas.'
  },
  {
    question:
      'Quais são as formas de pagamento disponíveis dentro do Riderize?',
    answer: 'São aceitos cartão (com ou sem juros), pix, boleto ou PicPay.'
  },
  {
    question:
      'A plataforma realiza o envio de um e-mail de confirmação de inscrição aos participantes?',
    answer:
      'Sim, há o envio automático de um e-mail de confirmação com todos os detalhes da inscrição em uma prova ou desafio. Caso o participante compre um produto ou serviço, ou mesmo pague pela inscrição, estará descrito no e-mail de confirmação.'
  },
  {
    question:
      'É possível criar/enviar e-mails aos participantes pela plataforma do Riderize?',
    answer:
      'Não, até o momento a plataforma faz apenas o envio desse primeiro e-mail automático de confirmação, então toda e qualquer nutrição por e-mail precisa ser feita pelo organizador, na ferramenta de disparo de e-mail que ele utiliza.'
  },
  {
    question:
      'O Riderize disponibiliza alguma comunicação visual para divulgar o evento?',
    answer:
      'Ao criar o evento de ciclismo dentro da plataforma, ao final do passo a passo você tem acesso a um link compartilhável para divulgar a sua prova ou desafio e assim permitir que os ciclistas acessem e façam suas inscrições com facilidade.'
  },
  {
    question:
      'Existe algum local da página do evento que é possível disponibilizar o regulamento e autorizações para download?',
    answer:
      'Sim, no campo de downloads, dentro da aba de configurações do evento, você consegue subir esses e outros arquivos que considerar válido os participantes terem acesso.'
  },
  {
    question:
      'A emissão de etiquetas para envio de kits e produtos pelos Correios é feita automaticamente?',
    answer:
      'Sim, a emissão das etiquetas é realizada de forma automática, basta acessar o campo de expedição da plataforma, selecionar o participante, emitir a etiqueta, colar na embalagem e depositar no Correio mais próximo de você.'
  },
  {
    question: 'O cálculo de frete precisa ser feito um por um?',
    answer:
      'Não, assim que o participante faz a inscrição em alguma prova ou desafio e adquire um kit ou produto do evento, ele insere os dados para envio e o Riderize calcula o frete automaticamente, já efetuando a cobrança do frete no momento da compra.'
  }
];

export default faqContent;
